import { jsPDF } from "jspdf";
import { numberFormat } from "utils";
// import { toBahtText } from "utils/toBahtText";
import "resource/font/THSarabun-normal"
import "resource/font/THSarabun-bold"
import { printHeader } from "./pirntHeader";
import dayjs from "dayjs";
import { salaryDriverColNm } from "branch/pages/DriverSalary/constant";
import { blue, yellow } from "@mui/material/colors";


const salColNm = {
  ...salaryDriverColNm,
  SumInc: "รวมรายได้",
  SumDeduct: "รวมรายจ่าย"
}
export const printDriverSalary = ({ dialogData, dataTable, msData }) => {
  console.log("printDriverSalary::", dialogData, dataTable, msData)
  const companyData = msData.serverData.CompanyData
  const startY = 0.1
  const startX = 0.5
  const pageSize = [8.3, 11.7];
  const lineHeight = 0.21
  const contentSize = 14;
  const colNoW = 0.35
  const colJobOrdId = 0.4
  const colAptTmW = 0.45
  const colContNoW = 0.9
  const colLocW = 1.5
  const colTripW = 0.7
  const colOverNW = 0.6
  const colLiftW = 0.6
  const colDepotW = 0.6
  const colTollW = 0.6
  const colGateW = 0.6
  const colFuelW = 0.7
  const colOthW = 0.7
  const colTotalExpW = 0.8
  const colTotalOut = 0.8
  const colGrndTotal = 0.8
  const dataBoxW = colNoW + colJobOrdId + colAptTmW + colContNoW + colLocW + colTripW + colOverNW + colLiftW + colDepotW + colGateW
    + colFuelW + colTollW + colOthW + colTotalExpW + colTotalOut + colGrndTotal
  let yPos = startY
  let xPos = startX
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "in",
    format: pageSize
  });
  doc.setLineWidth(0.01)
  doc.setFont("THSarabun")

  const startTableX = startX - 0.2
  const MAX_PAGE_SIZE_1 = 17
  const MAX_PAGE_SIZE_2 = 25
  const totalPage = dataTable.length <= MAX_PAGE_SIZE_1 ? 1 : Math.ceil((dataTable.length - MAX_PAGE_SIZE_1) / MAX_PAGE_SIZE_2) + 1
  console.log("totalPage::", totalPage)
  // console.log("dataTable.length::", dataTable.length)
  // console.log("totalPage::", totalPage)


  const drawHeader = (label, width, xPos) => {
    doc.text(label, xPos + width / 2, yPos, { align: "center" })
    xPos += width
    return xPos
  }
  const drawText = (text, width, xPos) => {
    doc.text(text, xPos + 0.1, yPos,)
    xPos += width
    return xPos
  }
  const drawNumberTable = (number, width, xPos) => {
    doc.text(`${numberFormat(number)}`, xPos + width, yPos, { align: "right" })
    xPos += width
    return xPos
  }


  for (let pageNo = 1; pageNo <= totalPage; pageNo++) {
    if (pageNo !== 1) {
      doc.addPage(pageSize, "landscape")
    }
    doc.setFont("THSarabun")

    xPos = startX
    yPos = startY
    xPos = yPos = printHeader({ jsPDFDoc: doc, companyData, startX: xPos, startY: yPos }, xPos)

    //---------------------------------draw top right -------------------------------------
    yPos = startY + 0.2
    doc.setFont("THSarabun", "bold")
    doc.setFontSize(20)
    doc.text("รายละเอียดเงินเดือน", 9.8, yPos, { align: "center" })

    doc.setFont("THSarabun", "bold")
    doc.setFontSize(contentSize)
    const lineHeightTopRight = lineHeight + lineHeight / 5
    const yPosTopRight = yPos + lineHeightTopRight
    const xPosTopRight = 8.5
    xPos = xPosTopRight
    yPos = yPosTopRight

    doc.text("ประจำเดือน : ", xPos, yPos)
    yPos += lineHeightTopRight
    doc.text("พนักงาน: ", xPos, yPos)
    yPos += lineHeightTopRight
    doc.setFont("THSarabun", "normal")
    yPos = yPosTopRight
    xPos += 0.8
    doc.text(dayjs(dialogData.SalDte).format("MMMM YYYY"), xPos, yPos)
    yPos += lineHeightTopRight
    doc.setFontSize(contentSize + 3)
    doc.setFont("THSarabun", "bold")
    doc.text(dialogData.DrvNm, xPos, yPos)
    doc.setFontSize(contentSize)
    doc.setFont("THSarabun", "normal")
    yPos += lineHeightTopRight
    if (totalPage > 1) {
      doc.text(`(หน้า ${pageNo} / ${totalPage})`, xPos, yPos)
    }

    yPos += lineHeight + 0.15

    const numberColWidth = 1.6
    const gap = 0.2
    const summaryTableWidth = numberColWidth * 2 + gap + 0.2
    const drawNumber = (name, xPos, yPos) => {
      doc.text(salColNm[name] || "-", xPos, yPos)
      doc.text(`${numberFormat(+(dialogData[name] || 0))} บาท`, xPos + numberColWidth, yPos, { align: "right" })
    }

    const drawSummaryTable = (startTableX, startTableY) => {
      let tableYPos = startTableY - lineHeight
      let tableXPos = startTableX - 0.1
      doc.setFillColor(blue[100])
      doc.rect(tableXPos, tableYPos, summaryTableWidth, lineHeight + 0.1, "F")
      doc.line(tableXPos, tableYPos, tableXPos + summaryTableWidth, tableYPos)
      tableYPos += lineHeight + 0.1
      doc.line(tableXPos, tableYPos, tableXPos + summaryTableWidth, tableYPos)
      tableYPos += (lineHeight * 4) + 0.1

      doc.setFillColor(yellow[100])
      doc.rect(tableXPos, tableYPos, summaryTableWidth, lineHeight + 0.1, "F")
      doc.line(tableXPos, tableYPos, tableXPos + summaryTableWidth, tableYPos)
      tableYPos += lineHeight + 0.1
      doc.line(tableXPos, tableYPos, tableXPos + summaryTableWidth, tableYPos)
      doc.line(tableXPos, startTableY - lineHeight, tableXPos, tableYPos)
      doc.line(tableXPos + summaryTableWidth, startTableY - lineHeight, tableXPos + summaryTableWidth, tableYPos)
    }
    const startYData = yPos
    xPos = startTableX +0.05
    yPos = startYData
    if (pageNo === 1) {
      drawSummaryTable(xPos, yPos)
      doc.setFont("THSarabun", "bold")
      doc.text("รายได้", xPos + (numberColWidth * 2 + gap) / 2, yPos, { align: "center" })
      yPos += lineHeight + 0.1
      const startInTableData = yPos
      doc.setFont("THSarabun", "normal")
      drawNumber("SalAmnt", xPos, yPos, xPos)
      yPos += lineHeight
      drawNumber("IncAmnt2", xPos, yPos, xPos)
      yPos += lineHeight
      drawNumber("IncAmnt1", xPos, yPos, xPos)
      yPos += lineHeight
      drawNumber("IncAmnt3", xPos, yPos, xPos)
      yPos = startInTableData
      xPos += numberColWidth + gap
      drawNumber("IncAmnt4", xPos, yPos, xPos)
      yPos += lineHeight
      drawNumber("IncAmnt5", xPos, yPos, xPos)
      yPos += lineHeight
      drawNumber("OthAmnt", xPos, yPos, xPos)

      yPos = startYData + (lineHeight * 5) + 0.2
      doc.setFont("THSarabun", "bold")
      doc.text("รวมรายได้", xPos - numberColWidth, yPos)
      doc.text(`${numberFormat(dialogData.SumInc)} บาท`, xPos + numberColWidth, yPos, { align: "right" })
      if (dialogData.OthDscp) {
        doc.setFont("THSarabun", "bold")
        doc.setFontSize(contentSize - 2)
        doc.text(`*รายได้อื่นๆ : ${dialogData.OthDscp}`, xPos + numberColWidth, yPos + lineHeight + 0.04, { align: "right" })
        doc.setFontSize(contentSize)
      }

      const tableYPos = yPos += lineHeight

      xPos = startTableX + 3.85
      yPos = startYData
      drawSummaryTable(xPos, yPos)
      doc.setFont("THSarabun", "bold")
      doc.text("รายจ่าย", xPos + (numberColWidth * 2 + gap) / 2, yPos, { align: "center" })
      yPos += lineHeight + 0.1
      doc.setFont("THSarabun", "normal")
      drawNumber("DeAmnt1", xPos, yPos, xPos)
      yPos += lineHeight
      drawNumber("DeAmnt2", xPos, yPos, xPos)
      yPos += lineHeight
      drawNumber("DeSecDepAmnt", xPos, yPos, xPos)
      yPos += lineHeight
      drawNumber("DeEduLoanAmnt", xPos, yPos, xPos)
      yPos = startInTableData
      xPos += numberColWidth + gap
      drawNumber("DeSSAmnt", xPos, yPos, xPos)
      yPos += lineHeight
      drawNumber("DeTaxAmnt", xPos, yPos, xPos)
      yPos += lineHeight
      drawNumber("DeTfcFineAmnt", xPos, yPos, xPos)
      yPos += lineHeight
      drawNumber("DeOthAmnt", xPos, yPos, xPos)

      yPos = startYData + (lineHeight * 5) + 0.2
      doc.setFont("THSarabun", "bold")
      doc.text("รวมรายจ่าย", xPos - numberColWidth, yPos)
      doc.text(`${numberFormat(dialogData.SumDeduct)} บาท`, xPos + numberColWidth, yPos, { align: "right" })
      if (dialogData.DeOthDscp) {
        doc.setFont("THSarabun", "bold")
        doc.setFontSize(contentSize - 2)
        doc.text(`*หักอื่นๆ : ${dialogData.DeOthDscp}`, xPos + numberColWidth, yPos + lineHeight + 0.04, { align: "right" })
        doc.setFontSize(contentSize)
      }

      xPos = startTableX + 7.65
      yPos = startYData
      drawSummaryTable(xPos, yPos)
      doc.setFont("THSarabun", "bold")
      doc.text("สรุปยอด", xPos + (numberColWidth * 2 + gap) / 2, yPos, { align: "center" })
      yPos += lineHeight + 0.1
      doc.setFont("THSarabun", "normal")
      xPos += (numberColWidth + gap) / 2
      drawNumber("SumInc", xPos, yPos, xPos)
      yPos += lineHeight
      drawNumber("SumDeduct", xPos, yPos, xPos)
      yPos += lineHeight
      drawNumber("LeftAmnt", xPos, yPos, xPos)

      yPos = startYData + (lineHeight * 5) + 0.2
      doc.setFont("THSarabun", "bold")
      doc.text("ยอดคงเหลือ", xPos, yPos)
      doc.text(`${numberFormat(dialogData.SumInc - dialogData.SumDeduct + +(dialogData.LeftAmnt || 0))} บาท`, xPos + numberColWidth, yPos, { align: "right" })

      xPos = startTableX
      yPos = tableYPos + 0.18

      doc.text("รายละเอียดวิ่งงาน", xPos, yPos)
      doc.setFontSize(contentSize - 1)
    }

    const lineHeightTable = lineHeight - 0.01
    //-------------------------------------- Box Header --------------------------------------------------------


    yPos += lineHeightTable - 0.1
    doc.setFillColor(blue[100])

    doc.rect(xPos, yPos, dataBoxW, lineHeightTable + 0.1, "F")
    doc.line(xPos, yPos, xPos + dataBoxW, yPos)
    // doc.lines([[dataBoxW, 0], [0, lineHeightTable * 2], [dataBoxW * -1, 0], [0, lineHeightTable * 2 * -1]], startTableX, yPos, [1, 1], 'F', true)
    // doc.line(startTableX, yPos, startTableX + dataBoxW, yPos)
    // doc.lines([[dataBoxW, 0], [0, dataBoxH], [dataBoxW * -1, 0], [0, dataBoxH * -1]], startTableX, yPos, [1, 1], 'S', true)
    // xPos = startTableX + invNoColW
    // doc.line(xPos, yPos, xPos, yPos + dataBoxH)
    // xPos += invDteColW
    // doc.line(xPos, yPos, xPos, yPos + dataBoxH)
    // xPos += ownRcptColW
    // doc.line(xPos, yPos, xPos, yPos + dataBoxH)
    // xPos += cusRcptColW
    // doc.line(xPos, yPos, xPos, yPos + dataBoxH + lineHeightTable * 2)
    //------------------------------------- Text Header ----------------------------------------------------------
    yPos += lineHeightTable
    xPos = startTableX
    // doc.text("Job No.", xPos + jobNoColW / 2, yPos, { align: "center" })
    // xPos += jobNoColW
    xPos = drawHeader("No.", colNoW, xPos)
    xPos = drawHeader("ใบงาน", colJobOrdId, xPos)
    xPos = drawHeader("วันที่", colAptTmW, xPos)
    xPos = drawHeader("หมายเลขตู้", colContNoW, xPos)
    xPos = drawHeader("สถานที่", colLocW, xPos)
    xPos = drawHeader("ค่าเที่ยว", colTripW, xPos)
    xPos = drawHeader("ค้างคืน", colOverNW, xPos)
    xPos = drawHeader("ยกตู้", colLiftW, xPos)
    xPos = drawHeader("ค่าลาน", colDepotW, xPos)
    xPos = drawHeader("ผ่านท่า", colGateW, xPos)
    xPos = drawHeader("ทางด่วน", colTollW, xPos)
    xPos = drawHeader("น้ำมันเงินสด", colFuelW, xPos)
    xPos = drawHeader("ค่าอื่นๆ", colOthW, xPos)
    xPos = drawHeader("รวมค่าใช้จ่าย", colTotalExpW, xPos)
    xPos = drawHeader("เบิกล่วงหน้า", colTotalOut, xPos)
    xPos = drawHeader("เงินขาด-เกิน", colGrndTotal, xPos)
    yPos += 0.1
    doc.line(startTableX, yPos, startTableX + dataBoxW, yPos)
    //------------------------------------- Data ----------------------------------------------------------
    doc.setFont("THSarabun", "normal")
    yPos += lineHeightTable
    xPos = startTableX

    const startRow = pageNo === 1 ? 0 : MAX_PAGE_SIZE_1 + (pageNo - 2) * MAX_PAGE_SIZE_2
    const endRow = pageNo === 1 ? MAX_PAGE_SIZE_1 : MAX_PAGE_SIZE_1 + (pageNo - 1) * MAX_PAGE_SIZE_2
    console.log("pageNo::", pageNo, "startRow::", startRow, "endRow::", endRow)

    for (let i = startRow; i < endRow; i++) {
      if (i >= dataTable.length) break
      const data = dataTable[i]
      xPos = startTableX
      // for (const data of dataTable) {
      if (data.id === 0) {
        doc.setFont("THSarabun", "bold")
        doc.setFillColor(yellow[100])
        doc.rect(startTableX, yPos - 0.1, dataBoxW, lineHeightTable + 0.1, "F")
        doc.line(startTableX, yPos - 0.1, startTableX + dataBoxW, yPos - 0.1)
        yPos += 0.1
      }
      xPos = drawHeader(`${data.No || ""}.`, colNoW, xPos)
      xPos = drawHeader(`${data.JobOrdId || ""}`, colJobOrdId, xPos)
      xPos = drawHeader(`${data.AptTm ? dayjs(data.AptTm).format("DD/MM") : "-"}`, colAptTmW, xPos)
      xPos = drawText(`${data.ContNo || "-"}`, colContNoW, xPos)
      xPos = drawText(`${data.Loc || "-"}`, colLocW, xPos)
      xPos = drawNumberTable(+data.E83, colTripW, xPos)
      xPos = drawNumberTable(+data.E86, colOverNW, xPos)
      xPos = drawNumberTable(+data.E3, colLiftW, xPos)
      xPos = drawNumberTable(+data.E5, colDepotW, xPos)
      xPos = drawNumberTable(+data.E4, colGateW, xPos)
      xPos = drawNumberTable(+data.E84, colTollW, xPos)
      xPos = drawNumberTable(+data.E1000, colFuelW, xPos)
      xPos = drawNumberTable(+data.OthAmnt, colOthW, xPos)
      xPos = drawNumberTable(+data.ExpTotal, colTotalExpW, xPos)
      xPos = drawNumberTable(+data.TotalOut, colTotalOut, xPos)
      xPos = drawNumberTable(+(data.ExpTotal || 0) - data.TotalOut, colGrndTotal, xPos)
      yPos += lineHeightTable
    }

  }
  doc.line(startTableX, yPos - 0.1, startTableX + dataBoxW, yPos - 0.1)
  // let maxRow = MAX_PAGE_SIZE



  yPos += (lineHeight * 2) + 0.1

  doc.setFont("THSarabun", "normal")
  const signWidth = 1.5
  const startsignX = startTableX + 0.6
  const col1 = startsignX
  const col2 = startsignX + dataBoxW * 1 / 4
  const col3 = startsignX + dataBoxW * 1 / 2
  const col4 = startsignX + dataBoxW * 3 / 4

  doc.line(col1, yPos, col1 + signWidth, yPos)
  doc.line(col2, yPos, col2 + signWidth, yPos)
  doc.line(col3, yPos, col3 + signWidth, yPos)
  doc.line(col4, yPos, col4 + signWidth, yPos)
  yPos += lineHeight
  doc.text("ผู้จัดทำ", col1 + signWidth / 2, yPos, { align: "center" })
  doc.text("ผู้ตรวจสอบ", col2 + signWidth / 2, yPos, { align: "center" })
  doc.text("ผู้ตรวจสอบ", col3 + signWidth / 2, yPos, { align: "center" })
  doc.text("ผู้ตรวจสอบ", col4 + signWidth / 2, yPos, { align: "center" })

  doc.output('dataurlnewwindow');
}